import { Path, HcSparrowHawk } from "@dev/hc-talk-talk";
import { getApiBaseUrl } from '@/app/utils/EnvConfig';

export default class BasePath extends Path {
    constructor(primary: string, useAuthorizationToken: boolean = false) {
        super({
            primary,
            secondary: primary,
            primaryBaseUrl: getApiBaseUrl(),
            secondaryBaseUrl: `http://localhost:${HcSparrowHawk.port}/api/cip/`,
            useAuthorizationToken
        });
    }
}
